@switch (bannerStyle) {
  @case ('Full') {
    <div
      class="full-container relative mt-6 flex flex-col items-center md:justify-start justify-center gap-2 rounded-md px-4 py-2 text-white md:flex-row"
    >
      <div class="flex flex-col items-center md:flex-row">
        <div class="flex flex-col -mt-12 items-center md:mr-12">
          <img [src]="'/promotion-banner/eofy-2024/eofy-balloons.png' | staticAsset: 'image'" alt="30% off" class="h-28 lg:h-36" />
          <strong class="heading text-heading-2 uppercase flex text-center"> Sale on now! </strong>
        </div>
        <div class="flex flex-col items-center md:items-start gap-4 md:gap-1 text-center md:text-left">
          <p class="text-3xl font-bold">Share your 5 star reviews to 12 platforms!</p>
          <p class="uppercase text-2xl">30% off pro</p>
          <p class="text-highlight-blue uppercase text-heading-1">Save $356</p>
        </div>
      </div>
      <div class="mt-2 md:!absolute md:bottom-4 md:right-4 md:mt-0 gap-2">
        <a
          routerLink="/billing/plans"
          [queryParams]="{ tier: 'Professional' }"
          target="_blank"
          class="upgrade-button w-full"
          mat-flat-button
        >
          Claim Offer
        </a>
        <p class="uppercase text-highlight-blue">Expires June 30</p>
      </div>
    </div>
  }
  @case ('NoCta') {
    <div class="noCta-container relative mt-6 flex flex-col justify-between gap-2 rounded-md px-2 text-white md:flex-row md:px-2 lg:px-4">
      <div class="flex flex-col items-center text-center md:flex-row w-full">
        <div class="flex flex-col -mt-6 md:ml-2">
          <img [src]="'/promotion-banner/eofy-2024/eofy-balloons.png' | staticAsset: 'image'" alt="30% off" class="lg:h-36" />
          <strong class="heading font-bold uppercase -mt-4"> Sale on now! </strong>
        </div>
        <div class="mb-4 flex flex-col items-center md:mb-0 md:py-6 grow justify-start md:justify-center">
          <p class="subheading text-white text-center md:text-left text-heading-1">Get all the benefits of Pro at 30% off!</p>
          <p class="uppercase text-highlight-blue font-bold">Don&rsquo;t miss out</p>
        </div>
      </div>
    </div>
  }
  @case ('Small') {
    <div class="small-container bg-blue-90 rounded-md p-2 text-center font-bold text-white">
      Almost there! You&rsquo;re *this* close to getting <span class="text-highlight-blue">30% off</span> RateMyAgent Pro
    </div>
  }
}
